import React from "react";
import { useSelector } from "react-redux";
import { Dropdown, Icon } from "semantic-ui-react";
import { getLocale } from "../../../../utils/helperFunctions";
import useTheme from "../../../../hooks/useTheme";
import { AppPrimaryButton, PrimaryChip } from "../../../UI/CustomButtons";
import { AppColumn, AppRow, Wrap } from "../../../UI/Layouts";
import { SizedBox } from "../../../UI/Sizes";
import AppText from "../../../UI/Texts/AppTexts";
import UserActions from "../../../../utils/Constants/UserActions";
import "../../../../App.css";
import { t } from "i18next";
import { useResponsive } from "../../../UI/ResponsiveContext";

const WorkfieldSelectionSection = ({
  formData,
  updateFormData,
  onNext,
  onBack,
  errors,
}) => {

    const { isMobile } = useResponsive()
    const theme = useTheme();
  
  const core = useSelector((state) => state.core);
  const coreConstants = Object.freeze(core.constants);

  const workfieldOptions = (coreConstants.workfields ?? []).filter((e) => !e.isGroup).map((workfield) => {
    return {
      key: workfield.id,
      text: workfield.text[getLocale()],
      value: workfield.id,
      suggested: workfield?.suggestedForAdmin ?? false,
    }
  });



  const sortedWorkfieldsOptions = workfieldOptions.sort((a, b) =>
    a.text.localeCompare(b.text)
  );


  const suggestedWorkfields = workfieldOptions.filter((wf) => wf.suggested && !formData.workfields.includes(wf.key));


  const handleSelection = (e, { value }) => {
    if (!formData.workfields.includes(value)) {
      updateFormData("workfields", [...formData.workfields, value]);
    }
  };

  const handleRemoveWorkfield = (workfield) => {
    updateFormData(
      "workfields",
      formData.workfields.filter((w) => w !== workfield)
    );
  };

  return (
    <AppColumn>
      <AppRow mainAxisAlignment={"space-between"} crossAxisAlignment={"center"}>
        <AppText.HeadingBig className={'text-headline'} fontWeight={600}>
          {t('registration.select_workfield.title')}
        </AppText.HeadingBig >
        <AppPrimaryButton
          userActionKey={UserActions.workfields_selected} s
          size={"large"}
          onClick={onNext}
          style={{
            borderRadius: theme.radius.small,
          }}
        >
          {t('next')}
        </AppPrimaryButton>
      </AppRow>
      <SizedBox height={theme.spacing.contentPadding} />
      <AppRow crossAxisAlignment={"center"}>
        <Icon
          name="plus square"
          color={theme.primaryColor}
          style={{
            color: theme.primaryColor,
          }}
        />
        <AppText.Footnote>
          {t('registration.select_workfield.description')}
        </AppText.Footnote>
      </AppRow>
      <SizedBox height={theme.spacing.elementPadding} />
      <Dropdown
        placeholder={t('registration.select_workfield.dropdown.placeholder')}
        fluid
        selection
        error={errors.workfields}
        search
        options={sortedWorkfieldsOptions}
        onChange={handleSelection}
        style={{
          padding: theme.spacing.elementPadding,
          marginBottom: theme.spacing.contentElementPadding,
        }}
        className="custom-height-dropdown"
      />

      {suggestedWorkfields.length > 0 && <AppColumn>
        <AppText.Caption>{t('registration.select_workfield.suggested_workfields')}</AppText.Caption>
        <SizedBox height={theme.spacing.elementPadding} />
        <Wrap>
          {suggestedWorkfields.map((wf, index) => {
            return (
              <PrimaryChip
                key={index}
                onClick={() => handleSelection(null, { value: wf.key })}
                secondary
                small={isMobile}
                text={wf.text}
              />
            );
          })}
        </Wrap>
        <SizedBox height={theme.spacing.contentElementPadding} />
      </AppColumn>}
      {formData.workfields.length > 0 && (<AppColumn>
        <AppText.Caption>{t('registration.selected_workfield.title')}</AppText.Caption>
        <SizedBox height={theme.spacing.elementPadding} />
        <Wrap>
          {formData.workfields.map((workfield, index) => {
            const workfiedText = workfieldOptions.find((e) => e.key === workfield).text;

            return (
              <PrimaryChip
                key={index}
                small={isMobile}
                text={workfiedText}
                onRemove={() => handleRemoveWorkfield(workfield)} />
            );
          })}
        </Wrap>
      </AppColumn>)}


    </AppColumn>
  );
};

export default WorkfieldSelectionSection;